import React, { useEffect, useState } from 'react';
import './NetflixTitle.css';
import netflixSound from './netflix-sound.mp3';
import { useNavigate } from 'react-router-dom';
import logoImage from '../src/images/logo-2.png';

const NetflixTitle: React.FC = () => {
  const [isClicked, setIsClicked] = useState(false);
  const navigate = useNavigate();

  const handlePlaySound = () => {
    const audio = new Audio(netflixSound);
    audio.play().catch(() => {
      // Silently handle audio play errors (e.g., autoplay restrictions)
    });
    setIsClicked(true);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handlePlaySound();
    }
  };

  useEffect(() => {
    if (isClicked) {
      const timer = setTimeout(() => {
        navigate('/browse');
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [isClicked, navigate]);

  return (
    <main
      className="netflix-container"
      onClick={handlePlaySound}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label="Click or press Enter to start exploring Shivom Sharma's portfolio"
    >
      <h1 className="visually-hidden">
        Shivom Sharma — AI Lead Portfolio
      </h1>

      <img
        src={logoImage}
        alt="Shivom Sharma Portfolio - Click to enter and explore AI agent infrastructure, crypto research, projects, and professional experience"
        className={`netflix-logo ${isClicked ? 'animate' : ''}`}
        width="400"
        height="200"
      />

      {!isClicked && (
        <p className="click-to-begin" aria-live="polite">
          Click to begin
        </p>
      )}

      {isClicked && (
        <p className="visually-hidden" aria-live="polite">
          Loading portfolio, please wait...
        </p>
      )}

      <style>{`
        .visually-hidden {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }
      `}</style>
    </main>
  );
};

export default NetflixTitle;
